import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { nodeTypes, appLabels } from '../../../app/app-constant';
import { TagsService } from '../../services/tags.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {

  explandAll: boolean = false;
  userNodeType: string;
  nodeTypes = nodeTypes;
  appLabels = appLabels;
  uiVersion = environment.version;
  apiVersion: string;
  apiCordaVersion: string;

  constructor(private userService: UserService, private tagsService: TagsService) { }

  ngOnInit() {
    this.userNodeType = this.userService.nodeType;

    this.tagsService.view({});

    this.getBackendVersions();
  }

  getBackendVersions() {
    let that = this;
    this.userService.getApiVersion().subscribe( res => {
      that.apiVersion = res;
    },
    error => {
    });

    this.userService.getApiCordaVersion().subscribe( res => {
      that.apiCordaVersion = res;
    },
    error => {
    });
  }

  toggleExpandAll(expandFlag: boolean) {
    this.explandAll = expandFlag;

    this.tagsService.link({
      "event_action" : "accordion",
      "event_content": this.explandAll ? "expand all" : "collapse all"
    });
  }

  onTabOpen(event: any) {
    let accodionTextElems = event.originalEvent.target.parentElement.getElementsByClassName('ui-accordion-header-text');
    this.tagsService.link({
      "event_action" : "accordion",
      "event_content": accodionTextElems ? accodionTextElems[0].innerText : "" 
        + " : Expand"
    });
  }

  onTabClose(event) {
    let accodionTextElems = event.originalEvent.target.parentElement.getElementsByClassName('ui-accordion-header-text');
    this.tagsService.link({
      "event_action" : "accordion",
      "event_content": accodionTextElems ? accodionTextElems[0].innerText : "" 
        + " : Collapse"
    });
  }

}
